import type { Catalog } from "./catalog.js";

// European Portuguese (Portugal). Emergency register, plain language.
// Completed in C7 — full coverage of en.ts (enforced by test/i18n-coverage.test.ts).
export const ptPT: Catalog = {
  "app.name": "Beacon",
  // Onboarding — Promise
  "onboarding.promise.tagline": "Vizinhos a avisar vizinhos.",
  "onboarding.promise.proof.corroboration": "×14 corroborações em mediana por alerta",
  "onboarding.promise.proof.time": "menos de 90 s até um alerta corroborado",
  "onboarding.promise.proof.nosignup": "0 contas, números de telefone ou registos necessários",
  "onboarding.promise.continue": "Começar",
  "onboarding.promise.restore": "Recuperar a minha identidade",
  "onboarding.promise.step": "BEM-VINDO",
  // Onboarding — Permissions (JIT-honest)
  "onboarding.perms.step": "PASSO 2 / 3",
  "onboarding.perms.title": "Como o Beacon pergunta",
  "onboarding.perms.location": "A localização serve apenas para vigiar a sua zona. Pedimos da primeira vez que centrar o mapa.",
  "onboarding.perms.notifications": "As notificações transportam os alertas. Pedimos da primeira vez que aceitar.",
  "onboarding.perms.background": "A atualização em segundo plano mantém os alertas atempados. Opcional, pedida no contexto.",
  "onboarding.perms.later": "Configurar mais tarde",
  "onboarding.perms.continue": "Continuar",
  // Onboarding — Home
  "onboarding.home.step": "PASSO 3 / 3",
  "onboarding.home.title": "Onde é a sua zona?",
  "onboarding.home.radius": "Raio de vigilância",
  "onboarding.home.km": "{n} km",
  "onboarding.home.pickHint": "Mova o mapa para que o pino marque este local.",
  "onboarding.home.confirm": "Vigiar esta zona",
  "onboarding.home.browse": "Por agora, só explorar",
  "onboarding.home.locating": "A localizar…",
  "onboarding.home.located": "Pino na sua localização atual — ajuste se necessário.",
  "onboarding.home.unavailable": "Localização indisponível — mova o mapa até à sua casa.",
  // Now tab — status
  "now.meta": "{place} · {radius} km",
  "now.meta.ago": "há {m} min",
  "now.meta.justNow": "agora mesmo",
  "now.meta.none": "ainda sem eventos",
  "now.meta.net": "rede {v}",
  "now.meta.netDown": "rede —",
  "now.meta.info.title": "O que significam estes números",
  "now.meta.info.radius": "{radius} km — o raio de vigilância da sua zona.",
  "now.meta.info.area": "{area} — quando chegou o último evento da sua zona (incidente, propagação, tempo ou ajuda).",
  "now.meta.info.net": "rede {net} — quando o último evento foi ingerido em toda a rede, de qualquer fonte ou vizinho na Europa. Se isto avança e o seu não, a rede está bem e simplesmente não tem novidades para si.",
  "now.meta.info.feeds": "Fontes por trás do que vê: {feeds}.",
  "now.place.default": "a sua zona",
  "region.unsupported.title": "Fora da região mapeada",
  "region.unsupported.body": "Ainda não há mapa disponível nesta localização.",
  "now.status.step": "AGORA",
  "now.status.allClear": "Tudo calmo.",
  "now.status.stayAware": "Mantenha-se atento.",
  "now.status.nearby.fire": "Fogo por perto.",
  "now.status.nearby.flood": "Inundação por perto.",
  "now.status.nearby.earthquake": "Sismo sentido.",
  "now.status.nearby.conflict": "Perigo por perto.",
  "now.status.nearby.other": "Perigo por perto.",
  "now.status.nearby.traffic": "Perturbação de trânsito por perto.",
  "now.status.nearby.storm": "Tempestade por perto.",
  "now.status.nearby.snow": "Neve por perto.",
  "now.status.nearby.ice": "Gelo nas estradas por perto.",
  "now.status.nearby.heat": "Aviso de calor extremo.",
  "now.status.nearby.fog": "Nevoeiro denso por perto.",
  "now.status.nearby.hazmat": "Alerta de materiais perigosos por perto.",
  "now.status.nearby.outage": "Interrupção de serviço por perto.",
  "now.status.sub": "{distance} km · {place}",
  "now.status.sub.allClear": "Nada ativo dentro do seu raio de vigilância.",
  // Now tab — community strip
  "now.community.neighbors": "{n} vizinhos",
  "now.community.watching": "A VIGIAR",
  "now.community.helpers": "{n} ajudantes",
  "now.community.helpersLabel": "POR PERTO",
  "now.community.median": "<90s",
  "now.community.medianLabel": "ATÉ ALERTA CORROBORADO",
  "now.community.corroborated": "×{n}",
  "now.community.corroboratedLabel": "CORROBORADO",
  // Now tab — activity + report
  "now.activity.title": "POR PERTO",
  "now.activity.empty": "Nada por perto neste momento.",
  "now.pulse.live": "Rede ativa — último evento há {s} s",
  "now.pulse.quiet": "Rede calma há {m} min",
  "now.pulse.unreachable": "Não é possível contactar o relay",
  "now.pulse.area": "A sua área: último aviso há {m} min",
  "now.pulse.areaNone": "A sua área: ainda sem avisos",
  "now.zone.addHere": "Está fora dos seus locais vigiados — adicionar aqui como zona?",
  "now.activity.corroboration": "CORROBORADO ×{n}",
  "now.group.areas": "{n} zonas",
  "now.group.expand": "Mostrar zonas",
  "now.report.button": "Reportar",
  "now.recenter": "Recentrar em mim",
  "now.fitAll": "Ver todos os locais",
  "now.raw.toggle": "Relatórios brutos",
  "now.raw.list.title": "Relatórios ({n})",
  "now.raw.list.more": "+{n} mais",
  "now.raw.detail": "{hazard} · via {feed} · {time}",
  "now.report.title": "Relatório",
  "now.report.unverified": "Relatório não verificado — ainda não corroborado",
  "now.report.event": "Evento",
  "now.report.response": "Resposta",
  "now.report.severity": "Gravidade",
  "now.report.observed": "Observado",
  "now.report.source": "Fonte",
  "now.warning.viewSource": "Ver aviso completo ↗",
  // Report sheet — corroborate mode
  "report.corroborate.title": "Corroborar",
  "report.corroborate.q": "É este o {hazard} perto de {place}?",
  "report.corroborate.yes": "Sim, também o vejo",
  "report.corroborate.no": "Não, isto é diferente",
  // Report sheet — full flow
  "report.title": "Reportar um perigo",
  "report.step.what": "O que se passa?",
  "report.step.where": "Onde?",
  "report.step.howbad": "Quão grave?",
  "report.where.here": "Aqui (a sua zona)",
  "report.where.honesty": "Partilhado como o seu bairro, não a sua morada.",
  "report.where.pick": "Escolher um ponto no mapa",
  "report.where.pickHint": "Arraste o mapa para o alfinete ficar no local.",
  "report.where.current": "Localização atual",
  "report.where.home": "Casa",
  "report.where.pin": "Marcar no mapa",
  "report.where.selected": "A reportar em",
  "report.where.locating": "A localizar…",
  "report.where.locateFailed": "Não foi possível obter a sua localização — a reportar a partir de casa.",
  "report.note.placeholder": "Acrescente uma linha (opcional)",
  "report.next": "Seguinte",
  "report.back": "Voltar",
  "report.submit": "Enviar relato",
  "report.cancel": "Cancelar",
  "report.severity.label": "Gravidade",
  // Report sheet — confirmation
  "report.done.title": "Enviado",
  "report.done.body": "Visível para os vizinhos agora. Os alertas disparam quando outros corroborarem.",
  "report.done.close": "Concluído",
  "report.error": "Não foi possível enviar — pode tentar novamente.",
  // Hazards (controlled vocab)
  "hazard.fire": "Fogo",
  "hazard.flood": "Inundação",
  "hazard.earthquake": "Sismo",
  "hazard.conflict": "Perigo",
  "hazard.other": "Perigo",
  "hazard.traffic": "Trânsito", "hazard.storm": "Tempestade", "hazard.snow": "Neve",
  "hazard.ice": "Gelo", "hazard.heat": "Calor", "hazard.fog": "Nevoeiro",
  "hazard.hazmat": "Materiais perigosos", "hazard.outage": "Interrupção de serviço",
  // Chrome
  "tab.now": "Agora",
  "tab.help": "Ajuda",
  "tab.you": "Você",
  "tab.talk": "Conversa",
  "tab.beacon": "Definições do Beacon",
  "beacon.tab.step": "DEFINIÇÕES",
  "beacon.tab.title": "Beacon",
  // Talk tab
  "talk.scope.area": "A minha zona",
  "talk.scope.region": "Região alargada",
  "talk.region.size": "Tamanho da região: ~{km} km",
  "talk.band.area": "na tua zona",
  "talk.band.region": "a tua região · ~{km} km",
  "talk.band.distant": "distante",
  "talk.you": "Tu",
  "talk.empty": "Ainda não há mensagens. Cumprimenta a tua zona.",
  "zone.checking": "A verificar a sua área…",
  "zone.stalled": "Ainda sem ligação à rede — a continuar a tentar…",
  "zone.progress.windows": "histórico {done}/{total}",
  "zone.progress.attempts": "tentativa {done}/{total}",
  "zone.retry": "Tentar novamente",
  "talk.placeholder.locked": "🔒 mensagem indisponível",
  "talk.composer.placeholder": "Escreve para a tua zona…",
  "talk.composer.send": "Enviar",
  "talk.new.count": "{n} novas ↓",
  "talk.zone.home": "Home",
  "talk.zone.nearby": "Nearby",
  "talk.compose.noCell": "Waiting for this place's location…",
  "banner.simulation": "SIMULAÇÃO",
  "locale.switch": "Idioma",
  // Alert receipt — toast/takeover (C4)
  "alert.toast.new": "{hazard} reportado por perto",
  "alert.toast.escalation": "{hazard} por perto acabou de agravar",
  "alert.toast.inPath": "{hazard} aproxima-se de si",
  "alert.toast.reAlert": "{hazard} por perto — atualização",
  "alert.toast.allClear": "Tudo calmo perto de {place}",
  "alert.toast.sub": "{distance} km · {place}",
  "alert.toast.tap": "Toque para detalhes e passos de segurança",
  "alert.toast.more": "+{n} mais",
  "alert.severity.info": "AVISO",
  "alert.severity.warning": "ALERTA",
  "alert.severity.critical": "CRÍTICO",
  "alert.takeover.title": "{hazard} — aja agora",
  "alert.takeover.sub": "{distance} km de {place}",
  "alert.takeover.steps": "PASSOS DE SEGURANÇA",
  "alert.takeover.details": "Ver detalhes completos",
  "alert.takeover.dismiss": "Dispensar",
  "alert.takeover.dismissNext": "Dispensar e ver o próximo · mais {n}",
  // IncidentDetail (C4)
  "incident.detail.metrics.corroborated": "×{n}",
  "incident.detail.reports.title": "Relatórios por trás disto ({n})",
  "incident.detail.metrics.corroboratedLabel": "CORROBORADO",
  "incident.detail.metrics.first": "{ago}",
  "incident.detail.metrics.firstLabel": "PRIMEIRO RELATO",
  "incident.detail.metrics.spread": "{status}",
  "incident.detail.metrics.spreadLabel": "PROPAGAÇÃO",
  "incident.detail.spread.moving": "A mover-se ~{speed} km/h",
  "incident.detail.spread.stationary": "Parado",
  "incident.detail.spread.dissipating": "A abrandar",
  "incident.detail.spread.unknown": "—",
  "incident.detail.steps": "PASSOS DE SEGURANÇA",
  "incident.detail.directions": "Direções",
  "incident.detail.share": "Partilhar",
  "incident.detail.help": "Posso ajudar",
  "incident.detail.helpSoon": "A coordenação de ajuda chega em breve.",
  "incident.detail.flag": "Reportar um problema com este alerta",
  "incident.detail.flagSoon": "A sinalização chega em breve.",
  "incident.detail.back": "Voltar",
  "incident.detail.away": "{hazard} — a {n} km",
  "incident.detail.ago.min": "há {n} min",
  "incident.detail.ago.hr": "há {n} h",
  "incident.detail.ago.now": "agora mesmo",
  // IncidentDetail — details block (origin / how bad / status) + corroborate
  "incident.detail.meta.title": "DETALHES",
  "incident.detail.meta.origin": "Origem",
  "incident.detail.meta.severity": "Gravidade",
  "incident.detail.meta.status": "Estado",
  "incident.detail.origin.crowd": "Comunidade",
  "incident.detail.origin.authority": "Oficial",
  "incident.severity.1": "Ligeiro",
  "incident.severity.2": "Sério",
  "incident.severity.3": "Grave",
  "incident.status.open": "Ativo",
  "incident.status.sustained": "Em curso",
  "incident.status.closing": "A diminuir",
  "incident.status.closed": "Encerrado",
  "incident.detail.seeIt": "Também estou a ver",
  "incident.detail.seeItDone": "Obrigado — o seu relato foi adicionado.",
  "incident.detail.tab.safety": "Segurança",
  "incident.detail.tab.details": "Detalhes",
  "incident.detail.tab.actions": "Ações",
  "incident.detail.helpBrowse": "Ver pedidos de ajuda",
  // Safety steps — tone-invariant, per hazard (GUI §3)
  "safety.fire.1": "Saia cedo — não espere para ver as chamas.",
  "safety.fire.2": "Vá contra o vento e para terreno mais alto, longe do fumo.",
  "safety.fire.3": "Leve água, medicação e o telemóvel.",
  "safety.fire.4": "Se ficar encurralado, procure terreno limpo ou um edifício.",
  "safety.flood.1": "Suba já para terreno mais alto.",
  "safety.flood.2": "Nunca caminhe nem conduza por água em movimento.",
  "safety.flood.3": "Desligue a energia se a água subir dentro de casa.",
  "safety.flood.4": "Afaste-se de rios, valetas e pontes.",
  "safety.earthquake.1": "Baixe-se, abrigue-se e aguente até parar de tremer.",
  "safety.earthquake.2": "Afaste-se de janelas e mobília pesada.",
  "safety.earthquake.3": "Após o abalo, verifique fugas de gás e danos.",
  "safety.earthquake.4": "Conte com réplicas — esteja pronto a abrigar-se de novo.",
  "safety.conflict.1": "Afaste-se do perigo e procure abrigo.",
  "safety.conflict.2": "Fique baixo e mantenha paredes sólidas entre si e o perigo.",
  "safety.conflict.3": "Partilhe o seu estado com alguém de confiança.",
  "safety.conflict.4": "Siga as orientações de emergência locais.",
  "safety.other.1": "Afaste-se do perigo imediato.",
  "safety.other.2": "Avise os vizinhos que possam não o ter visto.",
  "safety.other.3": "Siga as orientações de emergência locais.",
  "safety.traffic.1": "Reduza a velocidade e aumente a distância.",
  "safety.traffic.2": "Siga os sinais e mude de faixa cedo.",
  "safety.traffic.3": "Considere uma rota alternativa.",
  "safety.storm.1": "Fique dentro de casa e longe das janelas.",
  "safety.storm.2": "Evite viajar até passar.",
  "safety.storm.3": "Prenda objetos soltos no exterior.",
  "safety.storm.4": "Mantenha-se afastado de árvores e linhas de energia.",
  "safety.snow.1": "Evite deslocações não essenciais.",
  "safety.snow.2": "Vista-se bem e mantenha o telemóvel carregado.",
  "safety.snow.3": "Desobstrua as saídas e verifique os vizinhos.",
  "safety.ice.1": "Tenha cuidado nas estradas e caminhos.",
  "safety.ice.2": "Reduza a velocidade e trave com suavidade.",
  "safety.ice.3": "Use calçado antiderrapante.",
  "safety.heat.1": "Beba água com frequência.",
  "safety.heat.2": "Fique à sombra ou em locais frescos.",
  "safety.heat.3": "Evite esforço ao meio-dia.",
  "safety.heat.4": "Verifique o estado de idosos e pessoas vulneráveis.",
  "safety.fog.1": "Reduza a velocidade e use médios.",
  "safety.fog.2": "Mantenha maior distância.",
  "safety.fog.3": "Evite ultrapassagens.",
  "safety.hazmat.1": "Entre num local e feche janelas e ventilações.",
  "safety.hazmat.2": "Evite a zona afetada.",
  "safety.hazmat.3": "Siga as instruções oficiais.",
  "safety.outage.1": "Poupe a bateria do telemóvel.",
  "safety.outage.2": "Use lanternas, não velas.",
  "safety.outage.3": "Verifique os vizinhos que possam precisar de ajuda.",
  "offline.strip": "OFFLINE · ÚLTIMA SINCRONIZAÇÃO {time}",
  // Help tab — need types (controlled vocab)
  "need.medical": "Médica",
  "need.rescue": "Resgate",
  "need.transport": "Transporte",
  "need.shelter": "Abrigo",
  "need.supplies": "Mantimentos",
  "need.hands": "Mãos",
  "need.other": "Outro",
  // Help tab — status block (GUI §4)
  "help.status.step": "AJUDA",
  "help.status.some": "{n} pessoas precisam de ajuda por perto.",
  "help.status.one": "1 pessoa precisa de ajuda por perto.",
  "help.status.none": "Não há pedidos abertos por perto.",
  "help.status.sub": "Mais perto: {need} · {distance} km",
  "help.status.subNone": "Verá aqui os pedidos abertos na sua zona.",
  // Helper mode card
  "help.helper.toggle": "Posso ajudar",
  "help.helper.intro": "Ofereça-se para ajudar vizinhos perto de si.",
  "help.helper.tagsLabel": "Com o que pode ajudar?",
  "help.helper.ttlLabel": "Durante quanto tempo?",
  "help.helper.ttl.today": "Hoje",
  "help.helper.ttl.week": "Esta semana",
  "help.helper.ttl.incident": "Durante este incidente",
  "help.helper.area": "Apenas a sua zona — localização aproximada, nunca a sua morada.",
  "help.helper.register": "Registar disponibilidade",
  "help.helper.registered": "Está disponível para ajudar. Mostraremos os pedidos por perto.",
  "help.helper.tierUnknown": "CONFIANÇA · cresce à medida que ajuda e é avalizado",
  // Requests near you (matcher A7 push, private SSE)
  "help.nearby.title": "Pedidos perto de si",
  "help.nearby.toast": "Alguém perto precisa de {need}",
  "help.nearby.empty": "Ainda sem correspondências — será notificado.",
  "help.offer.toast": "Alguém ofereceu-se para ajudar",
  "help.accept.error": "Ainda não foi possível aceitar — a sincronizar essa pessoa. Tente novamente daqui a pouco.",
  // Open requests list
  "help.list.title": "PEDIDOS ABERTOS",
  "help.list.empty": "Sem pedidos abertos na sua zona.",
  "help.list.verified": "◆",
  // Request detail + offer/accept (GUI §4)
  "help.detail.back": "Voltar",
  "help.detail.needLabel": "Precisa de {need}",
  "help.detail.urgencyLabel": "URGÊNCIA",
  "help.detail.location": "Apenas zona aproximada",
  "help.detail.honesty": "A morada exata só é partilhada se aceitarem a sua oferta.",
  "help.detail.offer": "Oferecer ajuda",
  "help.detail.submitOffer": "Enviar oferta",
  "help.detail.notePlaceholder": "Acrescente uma nota (opcional)",
  "help.detail.etaPlaceholder": "Tempo estimado em minutos (opcional)",
  "help.detail.offersTitle": "OFERTAS",
  "help.detail.offersEmpty": "Ainda sem ofertas. Os vizinhos verão este pedido.",
  "help.detail.accept": "Aceitar",
  "help.detail.accepted": "Aceite",
  "help.detail.acceptCaveat": "Aceitar partilha a sua localização exata com essa pessoa — a identidade não é verificada e não pode ser desfeito.",
  "help.detail.offerSent": "Oferta enviada. Será notificado se aceitarem.",
  // Create request sheet
  "help.create.button": "Pedir ajuda",
  "help.create.title": "Pedir ajuda",
  "help.create.step.need": "Do que precisa?",
  "help.create.step.what": "O que é necessário?",
  "help.create.step.urgency": "Qual a urgência?",
  "help.create.headlinePlaceholder": "Uma linha — do que precisa?",
  "help.create.peoplePlaceholder": "Quantas pessoas?",
  "help.create.urgencyLabel": "URGÊNCIA",
  "help.create.next": "Seguinte",
  "help.create.back": "Voltar",
  "help.create.submit": "Publicar pedido",
  "help.create.error": "Não foi possível publicar. Tente novamente.",
  "help.create.done.title": "Pedido publicado.",
  "help.create.done.body": "Os vizinhos por perto podem vê-lo agora e oferecer ajuda.",
  "help.create.done.close": "Concluído",
  // My activity
  "help.activity.title": "A SUA ATIVIDADE",
  "help.activity.mine": "O seu pedido",
  "help.activity.helping": "Está a ajudar",
  "help.activity.offered": "Ofereceu ajuda",
  "help.activity.pending": "Ainda não está na rede",
  "help.screen.resolvedDone": "Resolvido — marcado como concluído.",
  "help.screen.resolvedCancelled": "Este pedido foi cancelado.",
  "help.screen.loading": "A carregar o pedido…",
  "help.activity.activeTitle": "ATIVOS",
  "help.activity.resolvedTitle": "RESOLVIDOS",
  "help.activity.badge.done": "Concluído",
  "help.activity.badge.cancelled": "Cancelado",
  "help.activity.badge.active": "Ativo",
  // Coordination thread (GUI §4, §6)
  "help.thread.back": "Voltar",
  "help.thread.title": "Coordenação",
  "help.thread.precise": "Localização partilhada",
  "help.thread.preciseSelf": "A sua localização partilhada",
  "help.thread.heartbeat": "{name} · {state}",
  "help.thread.composePlaceholder": "Mensagem…",
  "help.thread.send": "Enviar",
  "help.thread.done": "Concluído",
  "help.thread.cantMake": "Não consigo ir",
  "help.thread.you": "Você",
  "help.thread.requester": "Quem pediu",
  "help.thread.helper": "Ajudante · {id}",
  "help.thread.resend": "Reenviar",
  "help.thread.empty": "Coordenem aqui. As mensagens são cifradas para todos neste pedido.",
  "help.thread.openMap": "Abrir mapa ↗",
  "help.confirm.cancel": "Cancelar",
  "help.confirm.done.title": "Marcar como concluído?",
  "help.confirm.done.body": "A pessoa que ajuda é avisada e passa a Resolvidos.",
  "help.confirm.done.confirm": "Marcar concluído",
  "help.confirm.cant.title": "Retirar a sua ajuda?",
  "help.confirm.cant.body": "O pedido reabre para outras pessoas por perto.",
  "help.confirm.cant.confirm": "Retirar",
  "help.status.chip.open": "Aberto",
  "help.status.chip.accepted": "Aceite",
  "help.status.chip.enroute": "A caminho",
  "help.status.chip.arrived": "Chegou",
  "help.status.chip.partial": "Parcial",
  "help.status.chip.done": "Concluído",
  "help.status.chip.cancelled": "Cancelado",
  // Lifecycle step labels (numbered-steps)
  "help.lifecycle.open": "Aberto",
  "help.lifecycle.offered": "Oferecido",
  "help.lifecycle.accepted": "Aceite",
  "help.lifecycle.enroute": "A caminho",
  "help.lifecycle.arrived": "Chegou",
  "help.lifecycle.done": "Concluído",
  // You tab (GUI §5)
  "you.step": "VOCÊ",
  "you.title": "Você e as suas definições",
  // Location & alerts
  "you.loc.title": "LOCALIZAÇÃO E ALERTAS",
  "you.loc.home": "Zona de residência",
  "you.loc.setHome": "Definir zona de residência",
  "you.loc.coords": "Coordenadas",
  "you.loc.change": "Alterar zona de residência",
  "you.loc.setHomeHint": "Escolha uma zona de residência para ver o mapa e receber alertas do que está perto de si.",
  "you.loc.radius": "Raio de vigilância",
  "you.loc.km": "{n} km",
  "you.loc.quiet": "Horas de silêncio",
  "you.loc.quietValue": "{start}:00 – {end}:00",
  "you.loc.quietOff": "Desligado",
  "you.loc.quietToggle": "Silenciar alertas não críticos durante a noite",
  "you.loc.autoDismiss": "Dispensar alertas após",
  "you.loc.autoDismiss.seconds": "{n}s",
  "you.loc.autoDismiss.never": "Permanecer até dispensar",
  "you.loc.minsev": "Gravidade mínima para alertar",
  "you.loc.addPlace": "Adicionar outro local",
  "you.loc.addCurrent": "Usar a localização atual",
  "you.loc.liveFollow": "Seguir a minha localização",
  "you.loc.liveFollowHint": "Alerta-o sobre perigos onde está enquanto o Beacon está aberto. Usa mais bateria; desativado por predefinição.",
  "you.loc.liveFollowUnavailable": "O acesso à localização está desligado. Ative-o no navegador para seguir a sua localização.",
  "you.loc.keepAwake": "Manter o ecrã ligado ao seguir",
  "you.loc.keepAwakeHint": "Mantém o ecrã ativo durante o seguimento em direto para nunca falhar um alerta. Se desativar, um dispositivo adormecido não o consegue avisar — uma limitação das aplicações web.",
  "you.sound.title": "Som de alerta",
  "you.sound.hint": "Toca um som breve na voz que escolheste quando surge um alerta. Desligado até o ativares; sempre silencioso durante as horas de silêncio.",
  "you.sound.preview": "Reproduzir amostra",
  "you.loc.travelRadius": "Raio em viagem",
  "you.loc.places": "LOCAIS VIGIADOS",
  "you.loc.placeUnnamed": "Local guardado",
  "you.loc.removePlace": "Remover",
  "now.watched.title": "Outros locais vigiados",
  "now.watched.alert": "Incêndio perto de {place}",
  "you.loc.editPlace": "Editar",
  "you.loc.placeName": "Nome",
  "you.loc.homeName": "Nome de casa",
  "you.loc.moveUp": "Mover para cima",
  "you.loc.moveDown": "Mover para baixo",
  // Voice (supporter-locked)
  "you.voice.title": "TOM",
  "you.voice.intro": "Escolha como o Beacon fala consigo.",
  "you.voice.official": "Oficial",
  "you.voice.human": "Humano",
  "you.voice.dark": "Humor negro",
  "you.voice.deadpan": "Impassível",
  "you.voice.nonna": "Avó",
  "you.voice.preview.official": "Incêndio reportado 3 km a norte. Corroborado por 14 vizinhos.",
  "you.voice.preview.human": "Há um fogo mesmo a norte de si — os seus vizinhos também o estão a ver.",
  "you.voice.preview.dark": "Fogo a norte. Tão boa altura como qualquer outra para testar os ténis.",
  "you.voice.preview.deadpan": "Fogo a norte. Registado.",
  "you.voice.preview.nonna": "Há um fogo mesmo a norte, querido — vai já, estou a falar a sério.",
  // Trust
  "you.trust.title": "CONFIANÇA",
  "you.trust.tier": "O seu nível",
  "you.trust.tierUnknown": "— fornecido pelo projetor (D2)",
  "you.trust.how": "Como cresce: idade da conta, relatos confirmados e avais.",
  "you.trust.factor.age": "Idade da conta",
  "you.trust.factor.confirmed": "Relatos confirmados",
  "you.trust.factor.vouches": "Avais",
  "you.trust.factorValue": "— fornecido pelo projetor (D2)",
  "you.trust.vouch": "Avalizar um vizinho",
  "you.trust.vouchHint": "Partilhe esta ligação pessoalmente com alguém de confiança.",
  "you.trust.vouchers": "Os seus avalistas",
  "you.trust.vouchersEmpty": "— fornecido pelo projetor (D2)",
  "you.trust.backup": "Cópia de segurança e rotação de chaves",
  "you.trust.export": "Transferir o meu ficheiro de recuperação",
  "you.trust.exportHint": "Este ficheiro é a sua conta. Guarde-o em local seguro e privado.",
  "you.trust.import": "Restaurar a partir de um ficheiro de recuperação",
  "you.trust.rotate": "Rodar as minhas chaves",
  "you.trust.rotateHint": "Substitui as suas chaves de assinatura. Transfira um novo ficheiro de recuperação depois.",
  "you.trust.rotated": "Chaves rodadas. Transfira agora o seu novo ficheiro de recuperação.",
  "you.trust.importBad": "Esse ficheiro não é um ficheiro de recuperação Beacon válido.",
  "you.trust.importOk": "Ficheiro de recuperação aceite. Será usado no próximo arranque.",
  "you.trust.capability.direct": "Os seus relatos alertam a sua área diretamente.",
  "you.trust.capability.needsConfirm": "Neste momento, um vizinho precisa de confirmar o seu relato antes de alertar a área.",
  "you.trust.capability.full": "Os seus relatos já têm peso total. Os alertas maiores ainda precisam de confirmação de alguns vizinhos — é assim que o Beacon mantém a confiança.",
  "you.trust.progress.confirmed": "Após mais {confirmed} relato(s) confirmado(s), os seus relatos terão mais peso.",
  "you.trust.progress.days": "Continue a usar o Beacon durante cerca de mais {days} dia(s) para construir reputação.",
  // Privacy
  "you.privacy.title": "PRIVACIDADE",
  "you.privacy.consentTitle": "Aquilo com que concordou",
  "you.consent.alerts": "Receber alertas para a minha zona",
  "you.consent.helperAvailability": "Partilhar a minha disponibilidade para ajudar",
  "you.consent.preciseLocationRelease": "Divulgar a localização exata quando aceito um pedido",
  "you.consent.publicMetrics": "Contribuir para métricas públicas anónimas",
  "you.privacy.export": "Exportar os meus dados",
  "you.privacy.exportHint": "Uma cópia portátil de tudo o que está neste dispositivo.",
  "you.privacy.erase": "Apagar-me",
  "you.privacy.eraseHint": "Cripto-destruição: as suas chaves são destruídas e os seus dados ficam inacessíveis em todo o lado.",
  // Segurança e privacidade — o que o chat de ajuda protege e os seus limites.
  "you.safety.title": "SEGURANÇA E PRIVACIDADE",
  "you.safety.intro": "O que é protegido quando pede ou oferece ajuda, e onde estão os limites.",
  "you.safety.toggle": "Como a sua segurança é protegida",
  "you.safety.e2ee.h": "As mensagens são cifradas ponta a ponta",
  "you.safety.e2ee.d": "Só você e a pessoa com quem se coordena as conseguem ler — nem a Beacon, nem o relé.",
  "you.safety.location.h": "A sua localização exata fica privada até aceitar",
  "you.safety.location.d": "Quem ajuda vê apenas a sua zona aproximada. Assim que aceita alguém, só essa pessoa recebe a sua localização precisa.",
  "you.safety.metadata.h": "A rede consegue ver que está a coordenar-se",
  "you.safety.metadata.d": "As suas palavras e o local exato estão ocultos, mas é visível que está a receber ajuda, a sua zona aproximada e a hora. Trate o seu bairro como público.",
  "you.safety.identity.h": "A identidade de quem ajuda não é verificada",
  "you.safety.identity.d": "Qualquer pessoa pode oferecer ajuda com qualquer nome. Partilhe dados sensíveis só quando tiver a certeza de com quem está a lidar.",
  "you.safety.irrevocable.h": "Partilhar a sua localização precisa não pode ser desfeito",
  "you.safety.irrevocable.d": "Depois de aceitar, essa pessoa fica com a localização que partilhou. Não há retorno.",
  "you.safety.forwardSecrecy.h": "As mensagens antigas dependem da segurança do seu dispositivo",
  "you.safety.forwardSecrecy.d": "A Beacon ainda não usa uma chave nova para cada mensagem, por isso uma chave roubada poderia expor conversas passadas. Mantenha o telemóvel bloqueado.",
  "you.safety.retention.h": "As mensagens expiram, mas não as pode apagar",
  "you.safety.retention.d": "As mensagens de coordenação desaparecem sozinhas ao fim de algum tempo. Ainda não há eliminação manual mensagem a mensagem.",
  // Erase confirmation (grave)
  "you.erase.title": "Apagar-se do Beacon?",
  "you.erase.body": "Isto destrói as chaves que desbloqueiam tudo o que partilhou. Os relatos e mensagens já nos telemóveis dos vizinhos não podem ser recolhidos, mas todo o resto fica permanentemente inacessível. Isto não pode ser desfeito.",
  "you.erase.confirmLabel": "Escreva APAGAR para confirmar",
  "you.erase.confirmWord": "APAGAR",
  "you.erase.cancel": "Manter a minha conta",
  "you.erase.confirm": "Apagar-me",
  "you.erase.done": "O seu pedido de apagamento está assinado e a caminho. Adeus.",
  // Support Beacon
  // App
  "you.app.title": "APLICAÇÃO",
  "you.app.language": "Idioma",
  "you.app.notifications": "Notificações",
  "you.app.notificationsOn": "Ligadas",
  "you.app.notificationsOff": "Desligadas",
  "you.notif.enabled": "Notificações ativadas. Será avisado mesmo com o Beacon fechado.",
  "you.notif.denied": "As notificações estão bloqueadas. Permita-as nas definições do navegador para ser avisado com o Beacon fechado.",
  "you.notif.unsupported": "Este navegador não consegue mostrar notificações com o Beacon fechado. Os alertas na app continuam a funcionar.",
  "you.notif.nopush": "Notificações permitidas, mas o envio ainda não está configurado neste servidor. Os alertas na app continuam a funcionar.",
  "you.notif.subfail": "Notificações permitidas, mas este dispositivo não conseguiu ativar o envio. Os alertas na app continuam a funcionar.",
  "you.notif.subfail.noservice": "Notificações permitidas, mas este dispositivo não tem serviço de envio (p. ex. sem Google Play). Os alertas na app funcionam; para os de segundo plano use o Chrome ou a futura app do Beacon.",
  "you.notif.dismissed": "Sem avisos com o Beacon fechado até permitir as notificações. Ative quando quiser.",
  "you.app.about": "Sobre o Beacon",
  "you.app.version": "Versão piloto",
  // Flags & appeals (only if non-empty)
  "you.flags.title": "AS SUAS SINALIZAÇÕES E RECURSOS",
  // E2 moderation — flag sheet
  "flag.title": "Comunicar um problema",
  "flag.intro": "As denúncias são privadas. O autor nunca sabe quem denunciou.",
  "flag.reason.falseReport": "Falso ou enganador",
  "flag.reason.spam": "Spam",
  "flag.reason.harassment": "Assédio",
  "flag.reason.dangerousAdvice": "Conselho perigoso",
  "flag.reason.harvestAttempt": "Tentativa de recolher localizações",
  "flag.reason.doxxing": "Divulgação de dados pessoais",
  "flag.reason.illegal": "Conteúdo ilegal",
  "flag.reason.other": "Outra coisa",
  "flag.submit": "Enviar denúncia",
  "flag.done": "Obrigado — os moderadores vão analisar.",
  "flag.error": "Não foi possível enviar. Tente novamente.",
  // E2 moderation — You transparency surface
  "you.flags.empty": "Nada aqui. Sem ações sobre os seus relatos.",
  "you.flags.actionLabel": "Ação sobre a sua atividade",
  "you.flags.weight": "Mostrado mais abaixo na ordenação",
  "you.flags.reversible": "Isto é reversível e tem prazo. Pode recorrer.",
  "you.flags.appeal": "Recorrer",
  "you.flags.expires": "Expira {date}",
  // E2 moderation — appeal sheet
  "appeal.title": "Recurso",
  "appeal.intro": "Explique porque deve ser revertido. Um moderador analisa.",
  "appeal.statement.placeholder": "Porque está errado?",
  "appeal.submit": "Enviar recurso",
  "appeal.done": "Recurso enviado. Verá o resultado aqui.",
  "appeal.error": "Não foi possível enviar o recurso. Tente novamente.",
  // E9 incident detail — trend / freshness / source / advanced (Task 3)
  "incident.detail.meta.lastConfirmed": "Última confirmação",
  "incident.detail.meta.wind": "Vento",
  "incident.detail.meta.trend": "Tendência",
  "incident.detail.meta.sources": "Fontes",
  "incident.detail.trend.rising": "A intensificar",
  "incident.detail.trend.steady": "Estável",
  "incident.detail.trend.falling": "A diminuir",
  "incident.detail.worsening": "A piorar",
  "incident.detail.adv.title": "Avançado",
  "incident.detail.adv.intensity": "Potência radiativa",
  "incident.detail.adv.mw": "{n} MW",
  "incident.detail.adv.peak": "(pico {n} MW)",
  "incident.detail.adv.trendAxes": "Detalhe da tendência",
  "incident.detail.adv.weight": "Peso de corroboração",
  "incident.detail.adv.identities": "Autoridades confirmadoras",
  "incident.detail.adv.axis.rising": "↑",
  "incident.detail.adv.axis.steady": "→",
  "incident.detail.adv.axis.falling": "↓",
  "incident.detail.wind": "{speed} km/h de {dir}",
  "compass.n": "N",
  "compass.ne": "NE",
  "compass.e": "E",
  "compass.se": "SE",
  "compass.s": "S",
  "compass.sw": "SO",
  "compass.w": "O",
  "compass.nw": "NO",
  "incident.source.nasa-firms": "NASA FIRMS",
  "incident.source.fogos.pt": "fogos.pt",
  "incident.source.anepc": "ANEPC",
  "now.activity.confirmedAgo": "confirmado {ago}",
  "now.activity.worsening": "▲ a intensificar",
  // Install pointer (M3)
  "you.get.title": "INSTALAR O BEACON NO TELEMÓVEL",
  "you.get.body": "Instale o Beacon para receber alertas mesmo com a aplicação fechada.",
  "you.get.cta": "Obter o Beacon",
  "install.title": "Instalar o Beacon no telemóvel",
  "install.desktop.intro": "O Beacon avisa-o de perigos próximos mesmo com a página fechada.",
  "install.desktop.scan": "Leia o código para abrir o Beacon no telemóvel.",
  "install.ios.intro": "Instale o Beacon para receber alertas mesmo com a aplicação fechada.",
  "install.ios.step.share": "Toque no botão Partilhar.",
  "install.ios.step.add": "Escolha «Adicionar ao ecrã principal».",
  "install.ios.step.open": "Abra o Beacon a partir do ecrã principal.",
  "install.ios.note": "Sem loja de aplicações, nada para transferir.",
  "install.android.intro": "Instale o Beacon para receber alertas mesmo com a aplicação fechada.",
  "install.android.install": "Instalar o Beacon",
  "install.android.apk": "APK autoalojado (sem Google)",
  "install.hint.title": "Instalar o Beacon",
  "install.hint.body": "Receba alertas mesmo com o Beacon fechado.",
  "install.hint.cta": "Instalar",
  "install.hint.dismiss": "Dispensar",
  // You-tab cleanup (field card + disclosures)
  "you.card.trusted": "Vizinho de confiança",
  "you.card.building": "A ganhar confiança",
  "you.card.neighbor": "Vizinho",
  "you.card.watch": "vigia de {n} km",
  "you.card.noHome": "Sem área de casa definida",
  "you.loc.alertDetail": "Afinar alertas",
  "you.loc.livePosition": "Posição em direto",
  "you.loc.level.off": "Desligado",
  "you.loc.level.info": "Info",
  "you.loc.level.warning": "Aviso",
  "you.loc.level.critical": "Crítico",
  "you.trust.howToggle": "Como funciona a confiança",
  "you.trust.keysToggle": "Chaves e recuperação",
  "you.privacy.dataToggle": "Os seus dados",
  "you.card.id": "ID Beacon",
  "you.loc.homeTitle": "CASA E LOCAIS",
  "you.loc.alertsTitle": "ALERTAS",
  "you.loc.removeConfirm": "Remover?",
  "you.loc.cancel": "Cancelar",
  // Advanced — raw-report layer (power-user opt-in)
  "you.raw.title": "Relatórios brutos (avançado)",
  "you.raw.toggle": "Mostrar relatórios individuais no mapa",
  "you.raw.warning": "Os relatórios brutos têm um volume muito superior ao dos incidentes confirmados e consomem mais dados e bateria. Ativar mesmo assim?",
  "you.raw.depth.label": "Quão longe carregar",
  "you.raw.depth.off": "Apenas em direto",
  "you.raw.depth.shallow": "Superficial",
  "you.raw.depth.medium": "Médio",
  "you.raw.depth.deep": "Profundo",
  // Advanced — spread-cone debug cells (authoritative H3 overlay)
  "you.cone.title": "Células do cone (avançado)",
  "you.cone.toggle": "Mostrar as células exatas do motor de alertas",
  "you.cone.helper": "Sobrepõe as células H3 autoritativas que o motor de alertas usa para decidir quem está na trajetória de um perigo — útil para verificar porque chegou ou não um alerta.",

  "commons.card.title": "O comum",
  "commons.card.thisPeriod": "Este período",
  "commons.card.runRate": "Custo recorrente face às contribuições",
  "commons.card.cumulative": "Histórico",
  "commons.card.oneTime": "Pontual (p. ex. desenvolvimento)",
  "commons.card.yourCost": "A tua parte justa até agora",
  "commons.card.yourGiven": "Contribuíste",
  "commons.card.operatorStated": "declarado pelo operador",
  "commons.card.chipIn": "Contribuir",
  "commons.card.chippedIn": "Já contribuíste este mês — obrigado.",
  "commons.card.need": "O Beacon precisou de {amount} este mês para te avisar.",
  "commons.card.viewTransparency": "Ver transparência",
  "commons.card.deficit": "Défice",
  "commons.card.surplus": "Excedente",
  "commons.card.empty": "Ainda não há atividade do comum.",
  "commons.chipIn.title": "Contribui para o comum",
  "commons.chipIn.pickToken": "Escolhe o que enviar",
  "commons.chipIn.amount": "Montante (opcional)",
  "commons.chipIn.getAddress": "Obter endereço",
  "commons.chipIn.address": "Envia para este endereço",
  "commons.chipIn.copy": "Copiar endereço",
  "commons.chipIn.copied": "Copiado",
  "commons.chipIn.deadline": "Paga em {min} min para seres creditado. Os pagamentos tardios também ajudam o comum, mas não aparecem no teu cartão.",
  "commons.chipIn.oneClick": "Pagar com a carteira ligada",
  "commons.chipIn.noWallet": "Nenhuma carteira do navegador detetada — digitaliza ou cola o endereço.",
  "commons.chipIn.sent": "Transação enviada",
  "commons.chipIn.error": "Não foi possível obter um endereço. Tenta novamente.",
  "commons.chipIn.intro": "Um contributo único para os custos de funcionamento desta instância — na cadeia, sem registo.",
  "commons.chipIn.network": "Envie em {network}",
  "commons.chipIn.wrongChain": "Envie apenas nesta rede — fundos noutra cadeia não podem ser detetados.",
  "commons.chipIn.afterTitle": "Depois de enviar",
  "commons.chipIn.afterDetect": "O teu depósito é detetado automaticamente na cadeia — não precisas de fazer mais nada.",
  "commons.chipIn.afterAppear": "Quando a rede confirmar (normalmente um ou dois minutos), aparece no comum e no seu cartão se pagou dentro do prazo.",
  "commons.chipIn.done": "Concluído",
  "commons.chipIn.close": "Fechar",
  "commons.received": "Contributo recebido. Obrigado!",
  "commons.chipIn.waiting": "À espera do teu depósito na cadeia…",
  "commons.chipIn.receivedTitle": "Contributo recebido",
  "commons.chipIn.receivedBody": "Obrigado por contribuir — já está no livro do comum.",
  "commons.privacy.hidden": "Oculto de todos",
  "commons.privacy.public": "Oculto em público, visto brevemente por esta instância",
  "commons.privacy.custodial": "O teu banco/fornecedor vê isto",
  "commons.transparency.title": "Transparência do comum",
  "commons.transparency.intro": "Calculado inteiramente a partir de eventos assinados no firehose. Qualquer pessoa pode reproduzi-lo de forma independente.",
  "commons.transparency.series": "Custo recorrente face às contribuições, por período",
  "commons.transparency.oneTimeSeries": "Custos pontuais, por período",
  "commons.transparency.projection": "Este período (estimativa, pró-rata)",
  "commons.transparency.history": "Histórico até à génese",
  "commons.transparency.basis": "Base do denominador",
  "commons.transparency.reproduce": "Reproduz isto a partir do firehose: cada dado é um evento assinado de custo ou contribuição.",
  "commons.transparency.colCost": "Custo recorrente",
  "commons.transparency.colContrib": "Contribuições",
  "commons.transparency.colNet": "Líquido",
  "commons.transparency.colOneTime": "Pontual",
  "commons.transparency.estimate": "estimativa",
};
